import * as React from "react";
const SvgPoll = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 7H15M6 12H19M6 17H11", stroke: "#93A29B", strokeWidth: 4, strokeLinecap: "round" }));
export default SvgPoll;
